"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _styles = require("@material-ui/core/styles");

var _elements = require("../../elements");

var _ContentModal = _interopRequireDefault(require("./ContentModal.css"));

var _utils = require("../../utils");

var ContentModal =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(ContentModal, _React$PureComponent);

  function ContentModal() {
    (0, _classCallCheck2.default)(this, ContentModal);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ContentModal).apply(this, arguments));
  }

  (0, _createClass2.default)(ContentModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          cancelLabel = _this$props.cancelLabel,
          children = _this$props.children,
          classes = _this$props.classes,
          fullScreen = _this$props.fullScreen,
          onAbort = _this$props.onAbort,
          onSuccess = _this$props.onSuccess,
          open = _this$props.open,
          successLabel = _this$props.successLabel,
          title = _this$props.title;
      return React.createElement(_Dialog.default, {
        open: open,
        onClose: onAbort,
        fullScreen: fullScreen,
        PaperProps: {
          classes: {
            root: classes.root
          }
        },
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description"
      }, React.createElement(_DialogTitle.default, {
        id: "alert-dialog-title",
        className: classes.title
      }, (0, _utils.isTextContent)(title) ? React.createElement(_elements.Typography, {
        variant: 'dialogHeader'
      }, title) : title, React.createElement(_IconButton.default, {
        "aria-label": "Close",
        className: classes.closeButton,
        onClick: onAbort
      }, React.createElement(_Close.default, null))), React.createElement(_DialogContent.default, {
        className: classes.content
      }, (0, _utils.isTextContent)(children) ? React.createElement(_elements.Typography, {
        variant: 'dialogContent'
      }, children) : children), React.createElement(_DialogActions.default, {
        className: classes.actions
      }, React.createElement(_elements.Button, {
        onClick: onSuccess,
        type: "primary"
      }, successLabel), React.createElement(_elements.Button, {
        onClick: onAbort,
        type: "tertiary"
      }, cancelLabel)));
    }
  }]);
  return ContentModal;
}(React.PureComponent);

ContentModal.defaultProps = {
  fullScreen: false,
  successLabel: 'OK',
  cancelLabel: 'Cancel'
};
ContentModal.propTypes = {
  /**
   * Label for cancel button
   */
  cancelLabel: _propTypes.default.node,

  /**
   * Dialog children, usually the included sub-components.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * If true, the dialog will be full-screen
   */
  fullScreen: _propTypes.default.bool,

  /**
   * Callback fired when the component requests to be closed or cancel button was clicked.
   */
  onAbort: _propTypes.default.func.isRequired,

  /**
   * Callback fired when success button was clicked.
   */
  onSuccess: _propTypes.default.func.isRequired,

  /**
   * 	If true, the Dialog is open.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * Label for success button
   */
  successLabel: _propTypes.default.node,

  /**
   * Title of the modal
   */
  title: _propTypes.default.string
};

var _default = (0, _styles.withStyles)(_ContentModal.default)(ContentModal);

exports.default = _default;